// Sample floor key: buildingId ||| floor floorId
export const isFloorData = (splitedData) => {
  if (splitedData.length !== 2) return false;
  const label = splitedData[1];
  return label[0] === ' ' && label.includes('floor');
};

// Sample floor key: name|||buildingId
export const isBuildingData = (splitedData) => {
  if (splitedData.length !== 2) return false;
  const id = splitedData[1];
  return id[0] !== ' ';
};

// Sample unit key: Unit unitNum |||unitId|||BuildingId
export const isUnitData = (splitedData) => {
  return splitedData.length === 4;
};

export const getFloorInfo = (splitData) => {
  const buildingId = splitData[0].trim();
  const floorLabel = splitData[1].trim();
  const floorId = floorLabel.split(' ')[1];
  return {
    id: floorId,
    buildingId
  };
};

export const getBuildingInfo = (splitedData) => {
  return {
    id: splitedData[1]
  };
};

export const getUnitInfo = (splitedData) => {
  return {
    id: splitedData[1],
    buildingId: splitedData[2],
    floorId: splitedData[3]
  };
};

export const getAllBuildingData = (selectedData) => {
  return selectedData.reduce((buildingIds, current) => {
    const splitedData = current.split('|||');
    if (isBuildingData(splitedData)) {
      const buildingInfo = getBuildingInfo(splitedData);
      buildingIds.push(buildingInfo.id);
    }
    return buildingIds;
  }, []);
};

export const getBuildingAndUnitData = (selectedData) => {
  const units = [];
  const buildingIds = {};
  selectedData.forEach((data) => {
    const splitedData = data.split('|||');
    if (isBuildingData(splitedData)) {
      const { id } = getBuildingInfo(splitedData);
      buildingIds[id] = true;
    } else if (isUnitData(splitedData)) {
      const unitInfo = getUnitInfo(splitedData);
      if (!buildingIds[unitInfo.buildingId]) {
        units.push(unitInfo);
      }
    }
  });
  // filtered the units which are selected before the whole building
  const unitsData = units.reduce((prev, cur) => {
    if (!buildingIds[cur.buildingId]) {
      prev.push(cur.id);
    }
    return prev;
  }, []);
  return {
    units: unitsData,
    buildings: Object.keys(buildingIds)
  };
};

const getFloorCount = (floors, buildingIds, buildingWithFloors) => {
  return floors.reduce((prev, floor) => {
    if (!buildingIds[floor.buildingId]) {
      if (!buildingWithFloors[floor.buildingId]) {
        buildingWithFloors[floor.buildingId] = {
          [floor.id]: true
        };
      } else {
        buildingWithFloors[floor.buildingId][floor.id] = true;
      }
      return prev + 1;
    }
    return prev;
  }, 0);
};

const getUnitCount = (units, buildingWithFloors, buildingIds) => {
  return units.reduce((prev, unit) => {
    if (buildingIds[unit.buildingId]) {
      return prev;
    }
    const floorsInBuilding = buildingWithFloors[unit.buildingId];
    if (floorsInBuilding && floorsInBuilding[unit.floorId]) {
      return prev;
    }
    return prev + 1;
  }, 0);
};

export const getSelectedCount = (selectedData) => {
  const units = [];
  const floors = [];
  const buildingWithFloors = {};
  const buildingIds = {};
  // get buildings
  selectedData.forEach((data) => {
    const splitedData = data.split('|||');
    if (isBuildingData(splitedData)) {
      const { id } = getBuildingInfo(splitedData);
      buildingIds[id] = true;
    } else if (isUnitData(splitedData)) {
      const unitInfo = getUnitInfo(splitedData);
      if (!buildingIds[unitInfo.buildingId]) {
        units.push(unitInfo);
      }
    } else if (isFloorData(splitedData)) {
      const floorInfo = getFloorInfo(splitedData);
      if (!buildingIds[floorInfo.buildingId]) {
        floors.push(floorInfo);
      }
    }
  });
  const floorsCount = getFloorCount(floors, buildingIds, buildingWithFloors);
  const unitsCount = getUnitCount(units, buildingWithFloors, buildingIds);
  return {
    units: unitsCount,
    floors: floorsCount,
    buildings: Object.keys(buildingIds).length
  };
};

export const getSelectionText = (organization, units, floors, buildings) => {
  const buildingText = `${buildings} building(s)`;
  const floorText = `${floors} floor(s)`;
  const unitText = `${units} Unit (s)`;
  let positiveCounts = (units > 0) + (floors > 0) + (buildings > 0);
  if (positiveCounts === 3) {
    return `${buildingText} , ${floorText} and ${unitText} in selection`;
  }
  if (positiveCounts === 2) {
    if (buildings > 0) {
      return `${buildingText} and ${floors > 0 ? floorText : unitText} in selection`;
    }
    return `${floorText} and ${unitText} in selection`;
  }
  if (units > 0) {
    return `${unitText} in selection`;
  } else if (floors > 0) {
    return `${floorText} in selection`;
  } else if (buildings > 0) {
    return `${buildingText} in selection`;
  }
  return '0 selection';
};

export const getBuildingTreeKey = (buildingName, buildingId) => `${buildingName}|||${buildingId}`;
export const getFloorTreeKey = (buildingId, floor) => `${buildingId} ||| floor ${floor}`;
export const getUnitTreeKey = (config, buildingId, floorId, unitId, unitNum) =>
  `${
    config?.suite_enabled ? 'Room' : 'Unit'
  } ${unitNum}|||${unitId}|||${buildingId}|||${floorId}`;

export function makePossessive(fullName) {
    const parts = fullName.trim().split(' ');
    const lastName = parts[parts.length - 1]
    const lastNameLetter = lastName.toLowerCase().charAt(lastName.length - 1);
  
    if (lastNameLetter === 's') {
      return fullName + '\'';
    } else {
      return fullName + '\'s';
    }
}